import React from "react";
import useAppDispatch from "../hooks/use-app-dispatch";
import useAppSelector from "../hooks/use-app-selector";
import { getUserLibrary } from "../app/api/question-api";
import { TailSpin } from "react-loader-spinner";
import PlenumLogoTitle from "./PlenumLogoTitle";
import QuestionCard from "./QuestionCard";
import useMount from "../hooks/use-mount";
import { useAuth, useUser } from "@clerk/clerk-react";

export default () => {
    const dispatch = useAppDispatch();
    const { user } = useUser();
    const { getToken } = useAuth();
    const { previousQuestions, fetchingLibrary, lastLibraryFetch } =
        useAppSelector((store) => store.question);

    useMount(async () => {
        if (!!user?.id && Date.now() > lastLibraryFetch) {
            const token = await getToken();
            dispatch(getUserLibrary({
                token: token ?? "",
                user: user.id,
            }));
        }
    });

    return (
        <div className="flex flex-col bg-darkblue min-w-[280px] w-[280px] h-screen px-4 pt-8 gap-6 overflow-hidden">
            <div className="hidden lg:block select-none">
                <PlenumLogoTitle />
            </div>

            <div className="flex flex-col gap-3 flex-1 overflow-hidden">
                <div className="flex flex-row items-center gap-2">
                    <p className="text-white text-sm font-semibold select-none">
                        Recent Chats
                    </p>
                    {fetchingLibrary && (
                        <TailSpin width={14} height={14} color="#717D96" />
                    )}
                </div>

                <div className="flex flex-col gap-2 overflow-y-auto flex-1 pr-1">
                    {previousQuestions?.map((q) => (
                        <QuestionCard key={q.id} question={q} />
                    ))}

                    {!fetchingLibrary && (!previousQuestions || previousQuestions.length === 0) && (
                        <p className="text-[#717D96] text-sm">
                            No recent chats yet.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};
